<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
  props: {
    roomData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    FileUpload: () => lazyLoadComponent(import('@views/chat/components/FileUpload')),
  },
  data() {
    return {
      isDataReady: false,
      form: {
        images: [],
      },
    }
  },
  watch: {
    roomData: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          let rawImages = val.images || []
          // 關鍵過濾：排除 [{path: null}] 這種無效資料
          // 這樣能確保傳入組件的是 []，從而觸發「點擊上傳」按鈕顯示
          const cleanedImages = rawImages.filter((img) => img && img.path)
          this.form.images = JSON.parse(JSON.stringify(cleanedImages))

          this.isDataReady = true
          this.$message.success('房型照片資料載入完成')
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    exit() {
      this.$router.push('/hotel?tab1=1')
    },
    getStepData() {
      return { images: this.form.images }
    },
  },
}
</script>

<template>
  <div class="container" style="margin-bottom:80px">
    <hgroup>
      <el-button class="is-round" @click="exit">
        <BaseIcon name="chevron-left" icon-style="fal" class="mr-2 text-secondary" />
        返回
      </el-button>
      <h1>房型照片</h1>
    </hgroup>
    <div class="content">
      <el-form ref="form" label-position="top" v-loading="!isDataReady">
        <p>住宿房型圖片</p>
        <el-form-item v-if="isDataReady" prop="images">
          <div class="uploaderContainer">
            <FileUpload
              v-model="form.images"
              class="uploaderContainer_uploader"
              :single="true"
              is-delete-save
              :show-upload="true"
              resource="hotel"
              :size-limit="2"
              :key="roomData ? roomData.id : 0"
            ></FileUpload>
            <div class="limit">
              圖檔最大 2 MB，檔案格式限 JPG 或 PNG。
              <br />
              圖片比例：16：9，建議尺寸：1920*600px
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  overflow: scroll;
  width: 100%;
  padding: 18px 20px 0;

  hgroup {
    display: flex;
    align-items: center;

    .el-button {
      margin-right: 20px;
    }
  }

  .content {
    margin-top: 10px;
    padding: 18px 20px 20px;
    background-color: #fff;
  }
}

.uploaderContainer {
  display: flex;

  &_uploader {
    border: none;
    > ::v-deep div {
      width: 382px;
      height: 216px;
      margin-bottom: 0;
    }
  }

  &_uploader + div {
    align-self: flex-end;
  }
}
</style>
